module.exports = __webpack_public_path__ + "img/mylibrary-logo.83b9166e.png";